import { Component } from '@angular/core';

@Component({
    selector: 'gl-splash-screen-legacy',
    templateUrl: './splash-screen-legacy.component.html',
    styleUrls: ['./splash-screen-legacy.component.scss']
})
export class SplashScreenLegacyComponent {}
